<template>
  <div v-if="notification && notification.show" class="notification-container">
    <div :class="['notification', notificationClass]">
      <button class="delete" @click="closeNotification"></button>
      {{ notification.message }}
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'AppNotification',
  setup() {
    const store = useStore()

    // Use notifications namespace to match how it's used in store registration
    const notification = computed(() => store.state.notifications.notification)

    const notificationClass = computed(() => {
      if (!notification.value) return 'is-info'
      
      const type = notification.value.type || 'info'
      const classes = {
        'info': 'is-info',
        'success': 'is-success',
        'warning': 'is-warning',
        'danger': 'is-danger',
        'error': 'is-danger'
      }
      return classes[type] || 'is-info'
    })

    const closeNotification = () => {
      store.dispatch('notifications/hideNotification')
    }

    return {
      notification,
      notificationClass,
      closeNotification
    }
  }
}
</script>

<style scoped>
.notification-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  max-width: 400px;
}

.notification {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>